module.exports = __webpack_public_path__ + "static/news_reporting_team-640489fc3eb636b1b439e0bf8b7ea6bf.jpeg";